import { inject, Injectable, signal } from '@angular/core';
import { UserDataResponse, UserRoleEnum } from '../models/support.dto';
import { SupportApiService } from '../api/support-api.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { catchError, tap } from 'rxjs';

declare global {
  interface Window {
    initizializeUser: (authenticated: boolean) => void;
    initizializeCovenant: (authenticated: boolean) => void;
    initizializeCovenantCollaborator: (authenticated: boolean) => void;
    logout: () => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private api = inject(SupportApiService);

  private user = signal<UserDataResponse | null>(null);
  private fallBackUserRole = signal<UserRoleEnum | null>(null);

  public user$ = toObservable(this.user.asReadonly());

  public userData = this.user.asReadonly();

  constructor() {
    window.initizializeUser = (authenticated: boolean) => {
      this.user.set({
        role: UserRoleEnum.user,
        authenticated: authenticated,
      });
    };

    window.initizializeCovenant = (authenticated: boolean) => {
      this.user.set({
        role: UserRoleEnum.covenant,
        authenticated: authenticated,
      });
    };

    window.initizializeCovenantCollaborator = (authenticated: boolean) => {
      this.user.set({
        role: UserRoleEnum.covenant_collaborator,
        authenticated: authenticated,
      });
    };

    window.logout = () => {
      this.user.set(null);
    };
  }

  readUserData() {
    return this.api.getUserData().pipe(
      tap((res) => {
        if (!res.authenticated && this.fallBackUserRole()) {
          res.role = this.fallBackUserRole()!;
        }
        this.user.set(res);
      }),
      catchError((err) => {
        this.user.set({
          role: this.fallBackUserRole()!,
          authenticated: false,
        });

        return err;
      })
    );
  }

  getFallbackUserRole() {
    return this.fallBackUserRole();
  }

  setFallbackUserRole(role: UserRoleEnum | null) {
    this.fallBackUserRole.set(role);
  }

  // mapRoleAuthToEnum(role: string) {
  //   switch (role) {
  //     case 'merchant':
  //     case 'covenant':
  //       return UserRoleEnum.covenant;
  //     case 'merchant_collaborator':
  //     case 'covenant_collaborator':
  //       return UserRoleEnum.covenant_collaborator;
  //     case 'utilizzatore':
  //     case 'user':
  //       return UserRoleEnum.user;
  //     default:
  //       return null;
  //   }
  // }
}
